(function () {

  const WISHLIST_KEY = "wishlist";


  function getWishlist() {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  }


  function saveWishlist(data) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(data));
  }


  window.initWishlistSystem = function (scope = document) {

    const wishlistButtons = scope.querySelectorAll(".wishlist_button");

    const wishlistData = getWishlist();


    wishlistButtons.forEach((button) => {

      const productId = button.dataset.productId;

      const exists = wishlistData.some(
        item => item.productId == productId
      );


      if (exists) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
      }

    });


    updateWishlistCount();


    const wishlistBlocks = document.querySelectorAll(
      ".js-wishlistBlock, .js-wishlistBlock1"
    );


    if (wishlistBlocks.length) {

      showLoading();

      requestAnimationFrame(()=>{
        displayWishlist();
      });

    }

  };



  function showLoading(){

    document.querySelectorAll(
      ".js-wishlistBlock, .js-wishlistBlock1"
    )
    .forEach(block=>{

      block.classList.add("is-loading");

      block.innerHTML = `
        <div class="wishlist-loading">
          <img src="https://cdn.shopify.com/s/files/1/0857/2085/8938/files/Animation_-_1741843753530.gif?v=1741843804">
        </div>
      `;

    });

  }



  function updateWishlistCount(){

    const count = getWishlist().length;


    document.querySelectorAll(
      ".wishlist-total-count"
    )
    .forEach(el=>{

      el.textContent = count;
      el.dataset.total = count;

    });

  }



  function displayWishlist(){

    const wishlistData = getWishlist();


    document.querySelectorAll(
      ".js-wishlistBlock, .js-wishlistBlock1"
    )
    .forEach(block=>{


      block.classList.remove("is-loading");


      if(!wishlistData.length){


        block.classList.add("is-empty");


        block.innerHTML = `
          <div>
            <img src="https://cdn.shopify.com/s/files/1/0857/2085/8938/files/Animation_-_1741693242592.gif?v=1741693298">
          </div>
        `;


        return;

      }



      block.classList.remove("is-empty");



      block.innerHTML = wishlistData.map(item=>{


        return `

        <div class="wishlist-product__list">

          <div class="c-product">


            <a href="${item.productUrl}">
              <img src="${item.productImg}" alt="${item.productTitle}">
            </a>



            <div class="remove_wishlist"
                 data-product-id="${item.productId}">

              ✕
              
            </div>



            <h3 class="c-product__title card__heading h5">

              <a href="${item.productUrl}">
                ${item.productTitle}
              </a>

            </h3>



            <p class="price-item price-item--sale">
              ${item.productPrice}
            </p>



            <div class="remove_move_cart">

              <div class="move_to_cart"

                data-product-id="${item.productId}"

                data-product-variant-id="${item.productVariant}">

                Move to Cart

              </div>


            </div>


          </div>


        </div>

        `;


      }).join("");

    });


  }





  if(!window.wishlistEventsLoaded){


    document.addEventListener("click",function(e){



      /*
        ADD / REMOVE WISHLIST
      */


      const button = e.target.closest(".wishlist_button");


      if(button){


        const product = {


          productId:
          button.dataset.productId,


          productTitle:
          button.dataset.productTitle,


          productImg:
          button.dataset.productImg,


          productPrice:
          button.dataset.productPrice,


          productUrl:
          button.dataset.productUrl,


          productVariant:
          button.dataset.productVariantId


        };



        let wishlist = getWishlist();



        const index = wishlist.findIndex(
          item =>
          item.productId == product.productId
        );



        if(index === -1){


          wishlist.push(product);

          button.classList.add("active");


        }else{


          wishlist.splice(index,1);

          button.classList.remove("active");


        }



        saveWishlist(wishlist);


        updateWishlistCount();

        displayWishlist();


      }






      /*
        REMOVE
      */


      const removeBtn =
      e.target.closest(".remove_wishlist");


      if(removeBtn){


        let wishlist = getWishlist();


        wishlist =
        wishlist.filter(
          item =>
          item.productId != removeBtn.dataset.productId
        );



        saveWishlist(wishlist);


        updateWishlistCount();

        displayWishlist();


      }






      /*
        MOVE TO CART
      */


      const moveBtn =
      e.target.closest(".move_to_cart");



      if(moveBtn){


        const variantId =
        moveBtn.dataset.productVariantId;



        moveBtn.innerHTML="Moving...";



        fetch("/cart/add.js",{

          method:"POST",

          headers:{
            "Content-Type":"application/json"
          },

          body:JSON.stringify({

            id:variantId,

            quantity:1

          })

        })


        .then(res=>res.json())


        .then(()=>{


          let wishlist=getWishlist();



          wishlist =
          wishlist.filter(
            item =>
            item.productId != moveBtn.dataset.productId
          );



          saveWishlist(wishlist);



          displayWishlist();

          updateWishlistCount();



          updateCartCount();

          fetchCartDrawer();



          setTimeout(()=>{

            const drawer =
            document.querySelector(
              "cart-drawer.drawer"
            );


            if(drawer){

              drawer.classList.add("active");

            }


          },500);



        })


        .catch(err=>{

          console.error(
            "Wishlist cart error",
            err
          );

        })

        .finally(()=>{

          moveBtn.innerHTML="Move to Cart";

        });


      }



    });



    window.wishlistEventsLoaded=true;


  }






  function fetchCartDrawer(){


    const drawer =
    document.querySelector(".cart-drawer");


    if(!drawer)return;



    fetch("/cart?sections=cart-drawer")

    .then(res=>res.json())

    .then(data=>{


      const html=data["cart-drawer"];


      if(!html)return;


      const temp=document.createElement("div");


      temp.innerHTML=html;



      const newContent =
      temp.querySelector(".cart__contents");



      const current =
      drawer.querySelector(".cart__contents");



      if(newContent && current){

        current.innerHTML =
        newContent.innerHTML;


      }


    });


  }






  function updateCartCount(){


    fetch("/cart.js")

    .then(res=>res.json())

    .then(cart=>{


      document.querySelectorAll(
        ".cart-count-bubble span"
      )
      .forEach(el=>{

        el.textContent =
        cart.item_count;

      });


    });


  }



  window.displayWishlist =
  displayWishlist;


  window.updateWishlistCount =
  updateWishlistCount;



  document.addEventListener(
    "DOMContentLoaded",
    ()=>{
      initWishlistSystem();
    }
  );



  document.addEventListener(
    "shopify:section:load",
    (e)=>{
      initWishlistSystem(e.target);
    }
  );



})();